module.exports = __webpack_public_path__ + "img/product-placeholder-49.1590497.png";